import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e27c1812"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "content-box__title"
}
const _hoisted_2 = { class: "content-box__content" }

import { computed, withDefaults } from 'vue';


export default /*#__PURE__*/_defineComponent({
  props: {
    title: { default: undefined }
  },
  setup(__props: any) {


const classname = computed<string[]>((): string[] => {
	const className: string[] = ['content-box'];
	return className;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["content-box", _unref(classname)])
  }, [
    (__props.title)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(__props.title), 1))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      _renderSlot(_ctx.$slots, "default")
    ])
  ], 2))
}
}

})